module.exports = __webpack_public_path__ + "ad037ba2fe2c4ad99d79782c8f445a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-19.jpg
// module id = 1159
// module chunks = 0